import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MyAccountContainer } from '@components/organisms/MyAccountContainer';
import { ResumedStatisticCard } from '@components/molecules/ResumedStatisticCard';
import { ChartCard } from '@components/molecules/ChartCard/ChartCard';
import { SITE_URLS } from '@constants';
import { useCustomNavigate } from '@hooks/useCustomNavigate';
import { usePermissionChecker, UserPermissions } from '@hooks/useHasPermission';
import { formatPrice } from '@utils/format';

interface DashboardProps {
    statistics: {
        totalTransactionsPrice: number;
        ordersCount: number;
        visitsCount: number;
    };
}

export const Dashboard: FC<DashboardProps> = ({ statistics }) => {
    const { navigate } = useCustomNavigate();
    const { can } = usePermissionChecker();
    const { t } = useTranslation();

    const translations = {
        title: t('dashboard-component.title'),
        totalTransactions: t('dashboard-component.statistics.total-transactions'),
        ordersCount: t('dashboard-component.statistics.orders-count'),
        visitsCount: t('dashboard-component.statistics.visits-count'),
        turnover: t('dashboard-component.statistics.turnover'),
        visitorsCount: t('dashboard-component.statistics.visitors-count'),
    };

    // if user does not have permission accessMerchantAreas, he can't access this page
    useEffect(() => {
        if (can(UserPermissions.accessMerchantAreas) === false) {
            navigate(`/${SITE_URLS.myProfile}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <MyAccountContainer title={translations.title}>
            <>
                {/* resumed statistics */}
                <div className="row row-gap-4 pt-4">
                    <div className="col-12 col-lg-4">
                        <ResumedStatisticCard
                            icon="fa-light fa-money-bill-wave"
                            description={translations.totalTransactions}
                            value={formatPrice(statistics.totalTransactionsPrice)}
                        />
                    </div>
                    <div className="col-6 col-lg-4">
                        <ResumedStatisticCard
                            icon="fa-light fa-basket-shopping"
                            description={translations.ordersCount}
                            value={statistics.ordersCount}
                        />
                    </div>
                    <div className="col-6 col-lg-4">
                        <ResumedStatisticCard
                            icon="fa-light fa-arrow-pointer"
                            description={translations.visitsCount}
                            value={statistics.visitsCount}
                        />
                    </div>
                </div>
                {/* charts */}
                <div className="row row-gap-4 pt-4">
                    <div className="col-12">
                        <ChartCard title={translations.turnover} />
                    </div>
                    <div className="col-12">
                        <ChartCard title={translations.visitorsCount} />
                    </div>
                </div>
            </>
        </MyAccountContainer>
    );
};
